<template>
  <div class="SDGList">
    <div class="display-flex justify-content-start flex-wrap">
      <div 
        class="itemWrapper"
        v-for="item in projects">
        <project-item 
          :item="item"
          :key="item.id">
        </project-item>
      </div>
    </div>
    <div class="container">
      <div class="pagination display-flex justify-content-center align-items-center">
        <a 
          :class="['pagination-btn', 'prev', { 'disabled': !prevPage } ]" 
          href="#" 
          @click.prevent="prevPageBtnClick"></a>
        <div class="num font-weight-700 font-size-11">
          <div class="currentPage color-black">
            {{ startIndex }} - {{ endIndex }} <span class="primary">DI</span> {{ count }}
          </div>
        </div>
        <a 
          :class="['pagination-btn', 'next', { 'disabled': !nextPage } ]" 
          href="#"
          @click.prevent="nextPageBtnClick"></a></a>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import { mapGetters, mapState, mapActions } from '@node_modules/vuex';
  import '@images/arrow.svg'
  import ProjectItem from '@components/project_item'
  import { TweenLite, ScrollToPlugin } from "@node_modules/gsap/all";

  const plugins = [ ScrollToPlugin ];

  export default {
    name: "SDGList",
    components: {
      ProjectItem
    },
    methods: {
      ...mapActions('sdgDetail', [
        'loadItems',
        'setCurrentPage'
      ]),
      
      async nextPageBtnClick(){
        if(!!this.nextPage){
          try{
            await this.loadItems(this.nextPage);
            this.setCurrentPage(this.currentPage + 1)
            TweenLite.to(window, 2, {scrollTo:'#projects'});
          }catch(err){
            console.log(err)
          }
        }
      },
      async prevPageBtnClick(){
        if(!!this.prevPage){
          try{
            await this.loadItems(this.prevPage);
            this.setCurrentPage(this.currentPage - 1)
            TweenLite.to(window, 2, {scrollTo:'#projects'});
          }catch(err){
            console.log(err)
          }
        }
      }
    },
    computed: {
      ...mapState('sdgDetail', [
        'currentPage',
        'projects',
        'nextPage',
        'prevPage',
        'count'
      ]),
      ...mapGetters('sdgDetail', [
        'startIndex',
        'endIndex'
      ])
    }
  };
</script>
<style lang="less" scoped>
  @import "~@root/less/func/variables";
  @import "~@root/less/func/elements";

  .SDGList{
    .itemWrapper{

      width: calc(50% - 7.5px);
      flex-basis: calc(50% - 7.5px);
      flex-grow: 0;
      margin-right: 15px;
      margin-bottom: 40px;
      &:nth-child(2n){
        margin-right: 0;
      }
      @media (min-width: @bootstrap-md){
        width: calc(25% - 11.25px);
        flex-basis: calc(25% - 11.25px);
        margin-bottom: 60px;
        &:nth-child(2n){
          margin-right: 15px;
        }
        &:nth-child(4n){
          margin-right: 0;
        }  
      }
    }

    .pagination{
      margin-top: 40px;
    }
    .pagination-btn{
      display: block;
      background-image: url(/static/dist/images/arrow.svg);
      background-repeat: no-repeat;
      background-position: center;
      width: 40px;
      height: 40px;
      border: 1px solid @lightgreen;
      border-radius: 2px;
      &.prev{
        transform: rotate(180deg);
      }
      &.disabled{
        opacity: 0.4;
        &:hover{
          cursor: default;
        }
      }
    }

    .num{
      margin-right: 20px;
      margin-left: 20px;
    }
  }
</style>
